exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".incident-code-pill[data-v-12934512]{display:inline-flex;align-items:center;padding:.24rem .55rem;border-radius:999px;background:rgba(var(--brand-primary-rgb),.08);color:var(--brand-primary);font-size:.76rem;font-weight:700;letter-spacing:.04em;white-space:nowrap}.incident-trip-cell[data-v-12934512]{display:inline-flex;flex-direction:column;line-height:1.35}.incident-trip-primary[data-v-12934512]{font-weight:600}.incident-trip-secondary[data-v-12934512]{font-size:.78rem;color:var(--muted-font-color)}", ""]);

// exports
